import { useCallback } from 'react';
import { useStore } from 'react-admin'
import { FormControl, Slider, Tooltip, Typography } from '@mui/material'
import { useColorGradient } from '../../hooks/use-color';


export const ColorOpacitySlider = () => {
  const [value, setValue] = useStore<number>('map.opacity', 0.5);
  const [colorGradient] = useColorGradient();

  const handleChange = useCallback((_: Event, value: number | number[]) => {
    setValue(value as number);
  }, [setValue]);

  const valuetext = (value: number) => `${value}%`;

  return (
    <FormControl sx={{ width: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Tooltip title={'Color Opacity'} placement='bottom-start'>
        <Slider
          defaultValue={0.5}
          getAriaValueText={valuetext}
          step={0.05}
          min={0.1}
          max={1.0}
          onChange={handleChange}
          value={value}
          valueLabelDisplay="off"
          sx={{
            '& .MuiSlider-thumb': {
              borderRadius: '1px',
              border: '1px solid #ccc',
              background: `linear-gradient(${colorGradient}, ${colorGradient})`, // fallback for gradient
              boxShadow: `0 0 0 4px rgba(255,255,255,${1 - value}) inset`, // white overlay based on opacity
              // The thumb is always white, but the gradient overlays with opacity
              position: 'relative',
              overflow: 'hidden',
              '&:before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                background: colorGradient,
                opacity: value,
                borderRadius: '1px',
                zIndex: 1,
              },
              backgroundColor: '#fff', // always white base
            },
            '& .MuiSlider-track': {
              borderRadius: '1px',
            },
            '& .MuiSlider-rail': {
              borderRadius: '1px',
            },
            width: '100%'
          }}
        />
      </Tooltip>
    </FormControl>
  )
};
